import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { GetLaborerSubmitedRatingsResponse } from 'api/laborerPortalAPI/authContract'
import {
  convertLaborerSubmitedRatings,
  LaborerSubmitedRatingInfo,
} from 'common/utils/convertResponse/convertLaborerAuthResponse'

type State = { response: Array<LaborerSubmitedRatingInfo> } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  response: [],
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_SUBMITED_RATINGS_ASYNC,
    Actions.GET_LABORER_SUBMITED_RATINGS_SUCCESS,
    Actions.GET_LABORER_SUBMITED_RATINGS_FAIL,
    GetLaborerSubmitedRatingsResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_SUBMITED_RATINGS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        response: convertLaborerSubmitedRatings(action.payload),
      }
    }
    case Actions.GET_LABORER_SUBMITED_RATINGS_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_LABORER_SUBMITED_RATINGS_FAIL: {
      return {
        ...state,
        ...action.status,
        response: [],
      }
    }
    default:
      return state
  }
}
